import { SharedService } from 'app/layout/components/shared.service';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { navigation } from 'app/navigation/navigation';
import { AlertService, AuthenticationService, StorageService, SocketService } from 'app/main/apps/_services';
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
//import { Router } from '@angular/router';
import { Router, NavigationEnd, NavigationStart, Event as NavigationEvent, } from '@angular/router';
import { User } from '../../../main/apps/_models';
import { environment } from 'environments/environment';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { InviteAssociateComponent } from './invite-associate/invite-associate.component';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { DocusignService } from 'app/main/apps/services/docusign.service';
import { UserSettingsService } from 'app/main/apps/services/userSetting.service';
import { MatIconRegistry } from '@angular/material/icon';
import { GeneralService } from 'app/main/apps/services/general.service';
import { ComponentUpdateService } from 'app/main/apps/services/update.service';

@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ToolbarComponent implements OnInit, OnDestroy {
  readonly IMAGE_PATH: string = environment.IMAGE_SERVER_PATH;
  COUNTRY: string = environment.COUNTRY;
  showNotification: boolean;
  showUpdates: boolean;
  currentUser$: Observable<User>;
  horizontalNavbar: boolean;
  rightNavbar: boolean;
  hiddenNavbar: boolean;
  languages: any;
  navigation: any;
  selectedLanguage: any;
  userStatusOptions: any[];
  unit_name: any;
  animal: string;
  first_name: string;
  name: string;
  UserName: string;
  message: string;
  currentUser: any;
  LastRetrivedNotificationID: number = null;
  unreadNotifications: any = [];
  unreadMessagesCount: number = 0;
  unreadUpdates: any = [];
  unreadMsgNotifications: any = [];
  unreadMsgCount: number = 0;
  unreadNotificationCount: number = 0;
  unreadUpdatesCount: number = 0;
  subdomain: string = location.host.split('.')[0];
  private _unsubscribeAll: Subject<any>;
  inviteAsso: any;
  mycheck: any;
  event$;
  isshow: boolean;
  generalConfig: any;
  //myFlag = false;

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  title = 'angular-idle-timeout';
  subscription: any;
  counterDocument: any;
  checkedNewDashboard = false;
  role: any;
  counterConnectifi = 0;

  values: any = {
    usd: 1,
    cad: 1.35
  }
  numberConvertCanada = 1.34645;
  viewCalculator = false;
  visibleCalculator = false;


  /**
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   * @param {FuseSidebarService} _fuseSidebarService
   * @param {TranslateService} _translateService
   */
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _fuseSidebarService: FuseSidebarService,
    private _translateService: TranslateService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private socketService: SocketService,
    public dialog: MatDialog,
    private storageService: StorageService,
    private idle: Idle,
    private keepalive: Keepalive,
    private _sharedService: SharedService,
    private docusign: DocusignService,
    private userSettingsService: UserSettingsService,
    private matIconRegistry: MatIconRegistry,
    private domSanitzer: DomSanitizer,
    private generalService: GeneralService,
    private updateService: ComponentUpdateService
  ) {
    this.currentUser = this.storageService.getItem("SignIn");

    this.matIconRegistry.addSvgIcon(
      'calculator',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/ion_calculator-outline.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'user-connectifi',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/connectifi/icon-connectifi.svg')
    );

    this.role = !this.currentUser?.switchUserprofile &&
      [8, 9, 10].indexOf(this.currentUser?.UserDetails?.UserTypeID) != -1
      ? "Seller"
      : "Buyer";
    this.checkedNewDashboard = localStorage.getItem('layout-dashboard') === 'new' ? true : false;
    // Set the defaults
    this.userStatusOptions = [
      {
        'title': 'Online',
        'icon': 'icon-checkbox-marked-circle',
        'color': '#4CAF50'
      },
      {
        'title': 'Away',
        'icon': 'icon-clock',
        'color': '#FFC107'
      },
      {
        'title': 'Do not Disturb',
        'icon': 'icon-minus-circle',
        'color': '#F44336'
      },
      {
        'title': 'Invisible',
        'icon': 'icon-checkbox-blank-circle-outline',
        'color': '#BDBDBD'
      },
      {
        'title': 'Offline',
        'icon': 'icon-checkbox-blank-circle-outline',
        'color': '#616161'
      }
    ];
    this.languages = [
      {
        id: 'en',
        title: 'English',
        flag: 'us'
      },
      {
        id: 'tr',
        title: 'Turkish',
        flag: 'tr'
      }
    ];
    this.navigation = navigation;
    // Set the private defaults
    this._unsubscribeAll = new Subject();
    let executeIdleFunction = localStorage.getItem('idleFunction') === 'true';

    if (executeIdleFunction) {

      // sets an idle timeout of 5 seconds, for testing purposes.
      idle.setIdle(3600);
      // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
      idle.setTimeout(5);
      // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
      idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

      idle.onIdleEnd.subscribe(() => {
        this.idleState = 'No longer idle.'
        // console.log(this.idleState);
        this.reset();
      });

      idle.onTimeout.subscribe(() => {
        this.idleState = 'Timed out!';
        this.timedOut = true;
        // console.log(this.idleState);
        // this.router.navigate(['/']);
        localStorage.setItem('idleFunction', 'false');
        this.logout();
      });

      idle.onIdleStart.subscribe(() => {
        // this.idleState = 'You\'ve gone idle, in 15 seconds you will be logged out.';
        // console.log(this.idleState);
        // this.alertService.alert(this.idleState);
      });

      idle.onTimeoutWarning.subscribe((countdown) => {
        this.idleState = 'You will be logged out in ' + countdown + ' seconds!'
        // console.log(this.idleState);
        this.alertService.alert(this.idleState);
      });

      // sets the ping interval to 30 seconds
      keepalive.interval(3600);

      keepalive.onPing.subscribe(() => this.lastPing = new Date());

      this.reset();
    }
  }
  /**
   * On init
   */
  async ngOnInit(): Promise<void> {

    let refresh = localStorage.getItem('refresh');

    if (refresh === '1') {
      window.location.reload();
      localStorage.setItem('refresh', '0');
    }

    // Subscribe to the config changes        
    this._fuseConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((settings) => {
      this.generalConfig = settings;
      this.horizontalNavbar = settings.layout.navbar.position === 'top';
      this.rightNavbar = settings.layout.navbar.position === 'left';
      this.hiddenNavbar = settings.layout.navbar.hidden === true;
    });
    this.selectedLanguage = _.find(this.languages, { 'id': this._translateService.currentLang });
    this.UserName = null;
    //this.inviteAsso = this.currentUser.UserDetails.UserTypeID;
    this.inviteAsso = this.currentUser ? this.currentUser.UserDetails.UserTypeID : null;
    //console.log('hello',this.inviteAsso);
    console.log("thiscurrentuserToolbar", this.currentUser)
    if (this.currentUser && this.currentUser.ChangePassword) {
      setTimeout(() => {
        // this.openSubDialog();
        this.router.navigateByUrl('/apps/change-password-one-time');
      }, 1000);
    }
    this.event$ = this.router.events.subscribe((event: NavigationEvent) => {
      //if (event instanceof NavigationStart) {
      if (event instanceof NavigationEnd) {
        this.currentUser = this.storageService.getItem('SignIn');
        if (this.currentUser && this.currentUser.ChangePassword) {
          setTimeout(() => {
            this.router.navigateByUrl('/apps/change-password-one-time');
          }, 1000);
        }
      }
    });
    if (this.currentUser && this.currentUser.InviteAssociate) {
      setTimeout(() => { this.openAssoDialog(); }, 1000);
    }
    this.currentUser$ = this.authenticationService.currentUserObservable();
    this.currentUser = this.storageService.getItem('SignIn');

    if (this.currentUser) {

      this.getNotification();
      this.getMessages();
      this.unreadUpdates = [
        // {
        //   Title: 'New Seller “Drag & Drop” Document Management and File Sharing Functionality.',
        //   link: 'https://vimeo.com/717924683'
        // },
        // {
        //   Title: 'New Buyer “Drag & Drop” Document Management and File Sharing Functionality.',
        //   link: 'https://vimeo.com/720281695'
        // },
        
        
        // {
        //   Title: 'New Security Enhancement “Session Timeout”  will log you out after 2 hours of inactivity.',
        //   link: ''
        // },
        // {
        //   Title: 'Multiple Individual Deal Site Creation - CSV Import',
        //   link: 'https://youtu.be/6gvE5wE325U'
        // },
      ]

      if(this.role === "Seller"){
        this.unreadUpdates.push({
          Title: 'Syndifi Connectifi SELLERS Tutorial',
          link: 'https://youtu.be/bQOzEtOac9U?si=IclruiFKXJLbJi2o'
        })
      }else if(this.role === "Buyer"){
        this.unreadUpdates.push({
          Title: 'Syndifi Connectifi BUYERS Tutorial',
          link: 'https://youtu.be/_jr67c9M6C4?si=PIoBIR1aum66bRxd'
        })
      }

      if (this.currentUser.UserDetails.UserTypeID === 5 || this.currentUser.UserDetails.UserTypeID === 11) {
        this.unreadUpdates.push({
          Title: 'Buyers Tutorials - Deals, Documents & Offers',
          link: 'https://www.youtube.com/watch?v=_YOy8u8yY7I'
        })
      }

      this.unreadUpdatesCount = this.unreadUpdates.length;

      let req = {
        signer: this.currentUser.UserDetails.UserID,
        logginAccessKey: this.currentUser.LoginSessionKey
      }

      let listDocuments = await this.docusign.listSignature(req);
      listDocuments = listDocuments.filter(function (item) {

        return item.status === 0;

      });

      this.counterDocument = listDocuments.length;

      this.subscription = this.updateService.componentUpdate$.subscribe(async () => {
        // Lógica para recargar el componente
        let req = {
          signer: this.currentUser.UserDetails.UserID,
          logginAccessKey: this.currentUser.LoginSessionKey
        }

        let listDocuments = await this.docusign.listSignature(req);
        listDocuments = listDocuments.filter(function (item) {

          return item.status === 0;

        });

        this.counterDocument = listDocuments.length;
      });

      if (this.currentUser['UserDetails'].UserTypeID === 2) {
        this.changeDashboard();
      }

      this.userSettingsService.getActualRole(this.currentUser);

    }

    //console.log('sadjsd',this.inviteAsso);

  }

  openNotification(state: boolean) {
    // console.log(state);
    this.showNotification = state;
    // this.unreadNotificationCount = 0;
    // this.unreadNotifications = [];
    this.LastRetrivedNotificationID = null;
  }

  openUpdates(state: boolean) {
    // console.log(state);
    this.showUpdates = state;
    this.unreadUpdatesCount = 0;
    this.unreadUpdates = [];
    // this.LastRetrivedNotificationID = null;
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  async logout() {
    await this.generalService.saveLogout().then((resp: any) => {})
    const reqData = {
      "SignOut": {
        "LoginSessionKey": this.currentUser.LoginSessionKey
      }
    };
    this.authenticationService.logout(reqData).subscribe(async(res: any) => {
      if ([200, 535].indexOf(res.ResponseCode) != -1) {
        this.socketService.disconnectSocket();
        localStorage.removeItem('layout-dashboard');
        if (this.subdomain === 'cp') {
          location.href = location.href.split("/syndesk")[0];
        } else {
          this.router.navigateByUrl('/apps/login');
          window.location.reload();
        }
      }
    });
  }
  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(undefined);
    this._unsubscribeAll.complete();
  }
  /**
   * Toggle sidebar open
   *
   * @param key
   */
  toggleSidebarOpen(key): void {
    this._fuseSidebarService.getSidebar(key).toggleOpen();
  }
  /**
   * Search
   *
   * @param value
   */
  search(value): void {
    // Do your search here...
    //console.log(value);
  }
  /**
   * Set the language
   *
   * @param lang
   */
  setLanguage(lang): void {
    // Set the selected language for the toolbar
    this.selectedLanguage = lang;
    // Use the selected language for translations
    this._translateService.use(lang.id);
  }
  openSubDialog() {
    const dialogref = this.dialog.open(ResetPasswordComponent, {
      panelClass: 'custom-dialog-class-for-min-height1'
    });
  }
  openAssoDialog() {
    const dialogref = this.dialog.open(InviteAssociateComponent, {
      // panelClass: 'custom-dialog-class-for-min-height1'
    });
    // dialogRef.afterClosed().subscribe(result => {

    // });
  }

  getRedirectUrl(element){
    let redirectUrl = "https://syndesk.syndifi.com/syndesk/#/apps"

    if(element.data){
      if(element.data.DealPoolID){
        redirectUrl = `${redirectUrl}/deal-pools?dealpool=${encodeURIComponent(JSON.stringify(element.data))}`
      }else{
        redirectUrl = `${redirectUrl}/deal-group?dealgroup=${encodeURIComponent(JSON.stringify(element.data))}`
      }
    }else if(element.chatId){
      redirectUrl = `${redirectUrl}/chats/${element.chatId}`
    }
    else{
      redirectUrl = `${redirectUrl}/deals-view/${element.dealId}`
    }

    return redirectUrl
  }
  
  getNotification() {
    this.socketService.getNotificationData().subscribe((r: any) => {
      for (var updateType in r) {
        switch (updateType) {
          case 'onAssociatedEntityUpdated':
            this.unreadNotificationCount += r.onAssociatedEntityUpdated.length;
            let processedNotifications = r.onAssociatedEntityUpdated.map(e => {
              return {...e, redirectUrl: this.getRedirectUrl(e.Parameters)}
            })
            // r.onAssociatedEntityUpdated[0].redirectUrl = this.getRedirectUrl(r.onAssociatedEntityUpdated[0].Parameters)
            console.log("r", r)
            this.unreadNotifications = [...processedNotifications, ...this.unreadNotifications]
            // this.unreadNotifications.push(...r.onAssociatedEntityUpdated);
            if (this.unreadNotifications.length > 20)
              this.unreadNotifications.splice(0, this.unreadNotifications.length - 10);
            // this.unreadNotifications = this.unreadNotifications.reverse();
            break;
          case 'offlineMessages':
            this.unreadNotificationCount += r.offlineMessages.length;
            this.unreadNotifications.push(...r.offlineMessages);
            // console.log(this.unreadMsgNotifications);
            if (this.unreadMsgNotifications.length > 20) {
              this.unreadMsgNotifications.splice(0, this.unreadMsgNotifications.length - 10);
            }
            break;
          case 'LastRetrivedNotificationID':
            this.LastRetrivedNotificationID = r.LastRetrivedNotificationID;
        }
      }
    });
  }
  getMessages() {
    this.socketService.getNotificationData().subscribe((r: any) => {
      console.log()
      for (var updateType in r) {
        switch (updateType) {
          case 'onAssociatedEntityUpdated':

            r.onAssociatedEntityUpdated.forEach(n => {
              if(n.EventID === '81'){
                this.unreadMessagesCount += 1
                this.unreadMsgNotifications.push(n);
              }
            });

            // this.unreadNotificationCount += r.onAssociatedEntityUpdated.length;
            // r.onAssociatedEntityUpdated[0].redirectUrl = this.getRedirectUrl(r.onAssociatedEntityUpdated[0].Parameters)
            // console.log("r", r)
            // this.unreadNotifications.push(...r.onAssociatedEntityUpdated);
            // if (this.unreadNotifications.length > 20)
            //   this.unreadNotifications.splice(0, this.unreadNotifications.length - 10);
            // this.unreadNotifications = this.unreadNotifications.reverse();
            break;
          case 'offlineMessages':
            this.unreadNotificationCount += r.offlineMessages.length;
            this.unreadNotifications.push(...r.offlineMessages);
            // console.log(this.unreadMsgNotifications);
            if (this.unreadMsgNotifications.length > 20) {
              this.unreadMsgNotifications.splice(0, this.unreadMsgNotifications.length - 10);
            }
            break;
          case 'LastRetrivedNotificationID':
            this.LastRetrivedNotificationID = r.LastRetrivedNotificationID;
        }
      }
      console.log("UnreadMessagesCount", this.unreadMessagesCount)
    });
  }

  markMessagesRead() {
    this.unreadMsgNotifications.forEach(n => {
      if (n.NotificationUID) {
        this.generalService.markNotificationRead(n.NotificationUID);
      }
    });
    this.unreadMsgNotifications = [];
    this.unreadMessagesCount = 0;
  }

  markNotificationsRead(notificationsType: string = 'general') {
    this.showNotification = true;
    if (this.LastRetrivedNotificationID) {
      //console.log('call markNotifications');
      this.socketService.getSocketData({
        'markNotifications': {
          "notificationsType": notificationsType,
          "lastRetrivedNotificationID": this.LastRetrivedNotificationID
        }
      }, () => {
        this.socketService.setNotificationData({});
      });
    }
  }
  markUpdatesRead() {
    this.showUpdates = true;
    // console.log('Updates');
    // if (this.LastRetrivedNotificationID) {
    //     //console.log('call markNotifications');
    //     this.socketService.getSocketData({
    //         'markNotifications': {
    //             "notificationsType": notificationsType,
    //             "lastRetrivedNotificationID": this.LastRetrivedNotificationID
    //         }
    //     }, () => {
    //         this.socketService.setNotificationData({});
    //     });
    // }
  }
  switchProfile(event: any) {
    // console.log("event", event.checked);
    this.mycheck = event.checked;
    this.currentUser.switchUserprofile = event.checked;
    this.authenticationService.setCurrentUserData(this.currentUser);
    let msg = `Switched to ${event.checked ? 'Buyer' : 'Seller'} Profile`
    window.location.reload();
    this.alertService.success(msg);
  }

  getColor(row) {
    var rowNo = (typeof row == 'number') ? row : row;
    var colors = ['#9358AC', '#FFB848', '#40AC42', '#4697CE', '#847F9F', '#00B7C5'];
    return (typeof colors[rowNo] != 'undefined') ? colors[rowNo] : colors[rowNo - 7];
  }
  getInitials(strName) {
    if (strName) {
      var arrWords = strName.split(' ');
      var initailsStr = '';
      for (var i in arrWords) {
        initailsStr += arrWords[i].charAt(0);
      }
      return initailsStr.slice(0, 2).toUpperCase();
    }
  }
  backToAdmin() {
    localStorage.removeItem('layout-dashboard');
    location.href = location.href.split("/syndesk")[0] + '/backToAdmin';
  }
  // mode(event){
  //    this.currentUser.switchUserprofile = event.checked;
  //    this.authenticationService.setCurrentUserData(this.currentUser);
  //    this.nam =`${event.checked ? 'Sellers':'Buyers'}`

  // }

  frame() {
    this.isshow = !this.isshow
  }

  changeDashboard() {
    this.checkedNewDashboard = !this.checkedNewDashboard;
    this.generalConfig.layout.dashboard = 'new';

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this._sharedService.getChangeDashboard().subscribe(
      status => { console.log('app.component -> ', status); }
    );

    // localStorage.setItem('layout-dashboard', 'new');
    // console.log(localStorage.getItem('layout-dashboard'));
    // console.log(this.generalConfig);
    window.location.reload();
  }

  usdToCad(inputValue: any) {
    // console.log(this.values);
    this.values.cad = (inputValue * this.numberConvertCanada).toFixed(2);
  }

  cadtoUsd(inputValue: any) {
    // console.log(this.values);
    this.values.usd = (inputValue / this.numberConvertCanada).toFixed(2);
  }

  openCalculator() {
    this.viewCalculator = !this.viewCalculator;
    if (this.viewCalculator) {
      this.visibleCalculator = !this.visibleCalculator;
    } else {
      setTimeout(() => {
        this.visibleCalculator = !this.visibleCalculator;
      }
        , 500);
    }
  }

  onNotificationClick(notification: any): void {
    if (notification.NotificationUID) {
      try {
        this.unreadNotifications = this.unreadNotifications.filter(n => n.NotificationUID !== notification.NotificationUID)
        this.unreadNotificationCount -= 1
        this.generalService.markNotificationRead(notification.NotificationUID);
        
      } catch (error) {
        
      }
    }

    if (notification.EventID == 52) {
      this.router.navigate(['/apps/chats']);
    } else if (notification.redirectUrl) {
      window.location.href = notification.redirectUrl;
    }
  }

  getNotificationTitle(notification: any): string {
    return notification.EventID == 65
      ? "You have invited a new buyer. Deal invitation has been sent."
      : notification.Title;
  }

  async getPendingConnecitifi() {
    try {
      let req = {
        typeUser: this.role,
        userId: this.currentUser?.UserDetails?.UserID,
      }
    
      await this.generalService.getPendingConnectifi(req).then((resp: any) => {
        if (resp !== "No exist data." && resp !== "No exist buyers.") {

          let tempCounter = 0;

          if(resp.length > 0){
            resp.forEach(e => {
                        if(e.statusRequest == 1 && e.RequestedBy != parseInt(this.currentUser?.UserDetails?.UserID)){
                          tempCounter += 1
                        }
                      });
          }

          console.log(tempCounter)

          
          this.counterConnectifi = tempCounter;
        }
      });

    }
    catch (err) {
      console.log(err);
    }
  }
}
